"use strict";

var _regeneratorRuntime = require("/codebuild/output/src532132034/src/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator");

function _typeof(obj) {
  "@babel/helpers - typeof";

  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _commonReact = require("@devsta/common-react");

var _uiKit = require("@devsta/ui-kit");

var _CampaignHeader = _interopRequireDefault(require("../../../common/components/CampaignHeader"));

var _Tags = _interopRequireDefault(require("../../../common/components/Tags"));

var _ViewCampaignList = _interopRequireDefault(require("./ViewCampaignList"));

var _utils = require("../../../common/utils");

require("../styles/_view-campaign.scss");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _getRequireWildcardCache() {
  if (typeof WeakMap !== "function") return null;
  var cache = new WeakMap();

  _getRequireWildcardCache = function _getRequireWildcardCache() {
    return cache;
  };

  return cache;
}

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  }

  if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
    return {
      default: obj
    };
  }

  var cache = _getRequireWildcardCache();

  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }

  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;

  for (var key in obj) {
    if (Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;

      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }

  newObj.default = obj;

  if (cache) {
    cache.set(obj, newObj);
  }

  return newObj;
}

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
  try {
    var info = gen[key](arg);
    var value = info.value;
  } catch (error) {
    reject(error);
    return;
  }

  if (info.done) {
    resolve(value);
  } else {
    Promise.resolve(value).then(_next, _throw);
  }
}

function _asyncToGenerator(fn) {
  return function () {
    var self = this,
        args = arguments;
    return new Promise(function (resolve, reject) {
      var gen = fn.apply(self, args);

      function _next(value) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
      }

      function _throw(err) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
      }

      _next(undefined);
    });
  };
}

function _slicedToArray(arr, i) {
  return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _nonIterableRest();
}

function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance");
}

function _iterableToArrayLimit(arr, i) {
  if (!(Symbol.iterator in Object(arr) || Object.prototype.toString.call(arr) === "[object Arguments]")) {
    return;
  }

  var _arr = [];
  var _n = true;
  var _d = false;
  var _e = undefined;

  try {
    for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) {
      _arr.push(_s.value);

      if (i && _arr.length === i) break;
    }
  } catch (err) {
    _d = true;
    _e = err;
  } finally {
    try {
      if (!_n && _i["return"] != null) _i["return"]();
    } finally {
      if (_d) throw _e;
    }
  }

  return _arr;
}

function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}

var ViewCampaign = function ViewCampaign(props) {
  var getInspirationCampaign = props.getInspirationCampaign,
      apiClient = props.apiClient,
      history = props.history,
      fetchAssets = props.fetchAssets,
      getInspirationCampaignPosts = props.getInspirationCampaignPosts,
      toggleInspirationFavourite = props.toggleInspirationFavourite;

  var _useState = (0, _react.useState)({
    campaign: {},
    error: false
  }),
      _useState2 = _slicedToArray(_useState, 2),
      state = _useState2[0],
      setState = _useState2[1];

  var fetchCampaign = (0, _react.useCallback)( /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
    var _ref2, campaign, error;

    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            _context.next = 2;
            return (0, _utils.getCampaign)({
              getInspirationCampaign: getInspirationCampaign,
              apiClient: apiClient
            });

          case 2:
            _ref2 = _context.sent;
            campaign = _ref2.campaign;
            error = _ref2.error;

            if (error) {
              setState(function (prev) {
                return _objectSpread({}, prev, {
                  error: true
                });
              });
            }

            setState(function (prev) {
              return _objectSpread({}, prev, {
                campaign: campaign
              });
            });

          case 7:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  })), [getInspirationCampaign, apiClient]);
  (0, _react.useEffect)(function () {
    fetchCampaign();
  }, [fetchCampaign]);
  var error = state.error,
      campaign = state.campaign;

  if (error) {
    return _react.default.createElement(_commonReact.Error, null);
  }

  var _ref3 = campaign || {},
      name = _ref3.name,
      coverImageKey = _ref3.coverImageKey,
      description = _ref3.description,
      tags = _ref3.tags;

  return _react.default.createElement("div", {
    className: "page"
  }, _react.default.createElement(_CampaignHeader.default, {
    coverImageKey: coverImageKey
  }, _react.default.createElement(_uiKit.PageHeader, {
    title: name,
    subtitle: "Inspiration",
    subtitleLink: "/",
    history: history
  })), _react.default.createElement("div", {
    className: "view-campaign__body"
  }, _react.default.createElement("p", null, description), _react.default.createElement(_Tags.default, {
    large: true,
    tags: tags
  }), _react.default.createElement(_ViewCampaignList.default, {
    getInspirationCampaignPosts: getInspirationCampaignPosts,
    fetchAssets: fetchAssets,
    history: history,
    toggleInspirationFavourite: toggleInspirationFavourite
  })));
};

var _default = (0, _react.memo)(ViewCampaign);

exports.default = _default;